import { useVideoBaseData } from './useVideoBaseData';
import { getXVideoList } from '@opm/services';

/**
 * X 渠道视频数据 Hook — 简化版（仅无限滚动卡片模式）
 */
export function useXVideoData({
  filter,
  defaultPageInfo = { page: 1, page_size: 40 },
  translateCategory,
}: {
  filter: any;
  defaultPageInfo?: { page: number; page_size: number };
  translateCategory?: (value: string, isEn: boolean) => string;
}) {
  return useVideoBaseData({
    filter,
    apiFunction: getXVideoList,
    defaultPageInfo,
    useFieldMapping: false,
    translateCategory,
    defaultSortKey: 'view_count',
    downloadKey: 'MarketingVideoXDownload',
    channel: "twitter"
  });
}
